import React, { useCallback, useEffect, useState } from 'react';
import { Grid } from '../../../../shared/grid';
import { getStationMeta } from 'src/apis/getWeatherCalls';
import { useStoreContext } from 'src/store/context';
import { useAddAlert } from 'src/store/actions';
import { alertMessages } from 'src/constants';
import { slopeConversion } from 'src/store/common';
import { Button } from '@mui/material';
import LaunchIcon from '@mui/icons-material/Launch';
import { ROUTE_PATHS } from 'src/routes';
import { useHistory } from 'react-router-dom';

type StationMetaDataPopUpProps = {
  id:any;
  setStationMeta:any;
};

export const StationMetaDataPopUp: React.FC<StationMetaDataPopUpProps>= ({id, setStationMeta}) =>{
  const [state, dispatch ] = useStoreContext();
  const history = useHistory();
  const [station, setStation] = useState<any>(null);
  const addAlert = useAddAlert(dispatch);
  const [stationFailCount, setStationFailCount] = useState<number>(0);

	const stationMeta = useCallback((id:any, counter: number) =>{
		(async()=>{
			try{
				const varRequest = {
					stationId: id.toString(),				
				};
				const response: any = await getStationMeta(varRequest, addAlert, state?.user);
				if(response){
          setStation(response);
          setStationMeta(response);
          setStationFailCount(0);
				}
        else{
          setStation(null)
          setStationMeta([]);
          setStationFailCount(counter+1)
        }
			}
			catch(error){
        console.log('error', error)
        setStation(null)
        setStationMeta([]);
        setStationFailCount(counter + 1)
				addAlert({
					id:'',
					message: alertMessages.retrievingStationData,
					type:'error-info',
					icon:'fa-exclamation-triangle'
				})
			}
		})();
	},[addAlert, setStation, setStationMeta, setStationFailCount, state?.user]);

  useEffect(()=>{
    stationMeta(id, stationFailCount)
    if(stationFailCount>0 && stationFailCount<4){
      stationMeta(id, stationFailCount);
    }
  },[id, stationMeta, stationFailCount]);

  const goToCatalog = () =>{
    history.push({ pathname: `${ROUTE_PATHS.table}/catalog/${station.station_id}`, state: {...station} })
  }
  return(
      station && 
      <div className="font-sans-sm" style={{fontSize:'12px'}}>
        <Grid row gap="sm" style={{paddingBottom:'.7rem'}}>
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              NETWORK
            </Grid>
            <Grid>
              {station.network_name}
            </Grid>
          </Grid> 
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              NETWORK ID
            </Grid>
            <Grid>
              {station.network_id}
            </Grid>        
          </Grid>  
          <Grid desktop={{col:4}}>
            <Grid desktop={{col:4}}>
              <Grid className="text-bold">
                OWNER
              </Grid>
              <Grid>
                {station.agency}
              </Grid>
            </Grid> 
          </Grid>
        </Grid>

        <Grid row gap="sm" style={{ paddingBottom: '.7rem' }}>
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              LATITUDE
            </Grid>
            <Grid>
              {station.latitude}
            </Grid>        
          </Grid>  
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              LONGITUDE
            </Grid>
            <Grid>
              {station.longitude}
            </Grid>  
          </Grid>
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              ELEVATION
            </Grid>
            <Grid>
              {station.elevation}
            </Grid>
          </Grid>
        </Grid>
      
        <Grid row gap="sm" style={{paddingBottom:'.7rem'}}>
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              GRASS TYPE
            </Grid>
            <Grid>
              {!station || station.fuel_models?.length < 1? null: (station.fuel_models[0].grasstype?.includes('P')? "PERENNIAL": station.fuel_models[0].grasstype?.includes('A')? "ANNUAL": "")}
            </Grid>
          </Grid> 
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              ASPECT/SLOPE
            </Grid>
            <Grid>
              {station?.aspect_direction}/ {!station || station.fuel_models?.length < 1 ? null:slopeConversion(station?.fuel_models[0]?.slopeclass)}
            </Grid>        
          </Grid>  
          <Grid desktop={{col:4}}>
            <Grid className="text-bold">
              AVG ANNUAL PRECIP
            </Grid>
            <Grid>
              {station.avg_annual_precip}
            </Grid>
          </Grid> 
        </Grid>
        {
          state.mapDataType === 'FireDanger' &&
          <Grid row gap="sm" style={{ paddingBottom: '.7rem' }}>
            <Grid desktop={{ col: 8 }}>
            </Grid>
            <Grid desktop={{ col: 4 }}>
              <Button onClick={goToCatalog} style={{textTransform: 'capitalize'}}>Go To Catalog <LaunchIcon fontSize='small' /></Button>
            </Grid>
          </Grid>
        }
    </div>
    
  );
}
    